"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungProperties = void 0;
const ArticleProperties_1 = require("../ArticleProperties");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Zugentlastung properties that are used by the individual applications.
 */
class ZugentlastungProperties {
}
exports.ZugentlastungProperties = ZugentlastungProperties;
_a = echain_shared_igus_fundamentals_1.AppName.EIQ, _b = echain_shared_igus_fundamentals_1.AppName.EKE;
ZugentlastungProperties[_a] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
ZugentlastungProperties[_b] = ArticleProperties_1.ALL_ARTICLE_PROPERTIES;
//# sourceMappingURL=ZugentlastungProperties.js.map